var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 24,
    viewBox: "0 0 54 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 23,
    rx: 11.5,
    fill: "#A8A8A8",
    stroke: "#303030"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 8.5,
    fill: "white",
    stroke: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5742 11.8164C24.5742 10.3906 24.957 9.27539 25.7227 8.4707C26.4883 7.66211 27.4766 7.25781 28.6875 7.25781C29.4805 7.25781 30.1953 7.44727 30.832 7.82617C31.4688 8.20508 31.9531 8.73438 32.2852 9.41406C32.6211 10.0898 32.7891 10.8574 32.7891 11.7168C32.7891 12.5879 32.6133 13.3672 32.2617 14.0547C31.9102 14.7422 31.4121 15.2637 30.7676 15.6191C30.123 15.9707 29.4277 16.1465 28.6816 16.1465C27.873 16.1465 27.1504 15.9512 26.5137 15.5605C25.877 15.1699 25.3945 14.6367 25.0664 13.9609C24.7383 13.2852 24.5742 12.5703 24.5742 11.8164ZM25.7461 11.834C25.7461 12.8691 26.0234 13.6855 26.5781 14.2832C27.1367 14.877 27.8359 15.1738 28.6758 15.1738C29.5312 15.1738 30.2344 14.873 30.7852 14.2715C31.3398 13.6699 31.6172 12.8164 31.6172 11.7109C31.6172 11.0117 31.498 10.4023 31.2598 9.88281C31.0254 9.35938 30.6797 8.95508 30.2227 8.66992C29.7695 8.38086 29.2598 8.23633 28.6934 8.23633C27.8887 8.23633 27.1953 8.51367 26.6133 9.06836C26.0352 9.61914 25.7461 10.541 25.7461 11.834ZM34.3184 16V7.41016H40.1133V8.42383H35.4551V11.084H39.4863V12.0977H35.4551V16H34.3184ZM41.6543 16V7.41016H47.4492V8.42383H42.791V11.084H46.8223V12.0977H42.791V16H41.6543Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "static/media/off.0ea50a17786b173c6e8c0970bc80ee86.svg";
export { ForwardRef as ReactComponent };